<div>
    <button type="button" class="btn btn-light btn-sm" (click)="toggleDisabled()">Toggle disabled</button>
</div>
<br>
<ng-select [multiple]="true" [(ngModel)]="selectedCars">
    <ng-option *ngFor="let car of cars" [value]="car.id" [disabled]="car.disabled">{{car.name}}</ng-option>
    <ng-option [value]="'custom'">Custom</ng-option>
</ng-select>

<br/>Selected car ID: {{selectedCars | json}}